export const GST_EXEMPT_TYPE_ID = '3';

export const YES_NO_OPTIONS = [
  { id: '1', name: 'Yes' },
  { id: '0', name: 'No' },
];

export const ATTACHMENT_FIELDS = [
  { key: 'pan_attachment', label: 'PAN Attachment' },
  { key: 'gst_attachment', label: 'GST Attachment' },
  { key: 'cancel_cheque_attachment', label: 'Cancelled Cheque Attachment' },
  { key: 'msme_attatchment', label: 'MSME Attachment' },
  { key: 'declaration_for_attatchment', label: 'Declaration Attachment' },
  { key: 'pf_attatchement', label: 'PF Attachment' },
  { key: 'esic_attatchemnt', label: 'ESIC Attachment' },
];

export const CREATE_INITIAL_FORM = {
  registration_type_of_gstin: '',
  gst_no: '',
  name_of_firm: '',
  state_code: '',
  geo_city_id: '',
  geo_pincode_id: '',
  vendor_address: '',
  vendor_address2: '',
  arn_no: '',
  fax_no: '',
  home_page: '',
  contact_person_name: '',
  contact_no: '',
  email: '',
  type_of_firm: '',
  pan_no: '',
  msme_reg_no: '',
  msme_reg: '',
  pf_reg_no: '',
  pf_reg: '',
  esic_reg_no: '',
  esic_reg: '',
  bank_name: '',
  beneficiary_name: '',
  currency_code: 'INR',
  ifsc_no: '',
  bank_address: '',
  bank_account_no: '',
  swift_code: '',
  iban: '',
  status: '2',
};

export const mapLookupOptions = (items = [], labelKeys = ['name', 'firm_name', 'registration_type']) =>
  (items || []).map((item) => {
    const label =
      labelKeys.map((k) => item[k]).find((v) => v != null && v !== '') ||
      item.code ||
      String(item.id);
    return { id: String(item.id), name: String(label) };
  });

export const mapStateOptions = (states = []) =>
  (states || []).map((s) => ({
    id: String(s.id),
    name: `${s.name || s.state_name} (${s.gst_state_code || ''})`.trim(),
    gst_state_code: s.gst_state_code,
  }));

export const mapCurrencyOptions = (codes = []) =>
  (codes || []).map((c) => ({
    id: c.code || String(c.id),
    name: c.code && c.description ? `${c.code} - ${c.description}` : c.code || String(c.id),
  }));
